var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { publishSlice } from 'app/stores/publish';
import { publishToAnnotely } from 'app/stores/publish/actions/annotely';
import { getPlatformTag, PlatformType, } from 'app/views/components/dialogs/publish/platform';
import { Capabilities } from 'app/utils/Capabilities';
import { Version } from 'app/utils/version';
import { rasterizeProjectAction } from '../../project/actions/rasterize';
import { getTokensForPlatform, isPublishingToPlatform } from '../selectors';
export const publishToPlatform = createAsyncThunk('publish/platform', (params, { getState, dispatch }) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const { platform, format: exportFormat } = params;
    // For annotely run a separate logic
    if (platform === PlatformType.Annotely) {
        dispatch(publishToAnnotely({ strategy: 'all_pages' }));
        return;
    }
    // All others are handled via oauth
    try {
        const state = getState();
        if (isPublishingToPlatform(state, platform)) {
            throw new Error('Already publishing');
        }
        const accessToken = (_a = getTokensForPlatform(state, platform)) === null || _a === void 0 ? void 0 : _a.accessToken;
        if (!accessToken) {
            throw new Error('Not authorized');
        }
        dispatch(publishSlice.actions.setJobState({
            platform,
            state: 'publishing',
            startedAt: Date.now(),
        }));
        const renders = yield dispatch(rasterizeProjectAction({
            format: exportFormat,
            strategy: 'current_page',
        })).unwrap();
        if (!renders || !renders.length) {
            throw new Error('Renderer failed');
        }
        const { browserParser } = Capabilities.shared;
        const headers = {
            Authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/octet-stream',
            'X-Annotely-Id': JSON.stringify({
                version: Version.version,
                deviceId: browserParser.getBrowserName(),
                device: browserParser.getOSName(),
                format: exportFormat,
                app: 'Annotely',
            }),
        };
        // validate all renders
        renders.forEach((render, index) => {
            if (!render || !render.data || !render.data.size) {
                throw new Error(`Missing render data; index=${index}`);
            }
        });
        // todo publish multiple
        const index = 0;
        const render = renders[index];
        const data = yield axios
            .post(`/api/integrations/publish/${getPlatformTag(platform)}`, render.data, {
            headers,
        })
            .then(response => response.data);
        dispatch(publishSlice.actions.setJobState(Object.assign({ platform, state: 'published', publishedAt: Date.now() }, data)));
    }
    catch (err) {
        getLogger('PlatformPublish', 'error')(err);
        const reason = err instanceof Error ? err.message : 'n/a';
        dispatch(publishSlice.actions.setJobState({
            platform,
            state: 'error',
            message: `Platform publish error; reason=${reason}`,
        }));
    }
}));
